/*** IMPORTS FROM imports-loader ***/
(function() {
var app = window.app||{};
var define = false;
var exports = false;
var module = undefined;

var app = app || {};

(function ($) {
  'use strict';

  /**
   * Вид для страницы торговой марки "ArtUzor"
   */
  app.ArtUzorView = app.View.extend({
    el: '[data-jsmodel = "art-uzor"]',

    events: {
      'click .js-scroll-link': 'scrollToIdBlock',
      'click .control-arrows.arrow-up': 'newsScrollUp',
      'click .control-arrows.arrow-down': 'newsScrollDown',
      'click .videobl': 'toggleMainVideo',
    },

    run: function () {
      var src = this.$('.video-wrapper video').attr('src');
      var poster = this.$('.video-wrapper video').attr('poster');
      var description = this.$('.video-wrapper .name-video').text();
      this.videoView = new app.BaseVideoView({'el': this.$('.video-wrapper'), templateName: '#video-template'});
      this.videoView && this.videoView.render(src, poster, description);
      this.template = app.helpers.TemplateHelper.getTemplate('#video-description-template');
    },

    /**
     * Скролл страницы до блока.
     * @param {Event} e Событие
     */
    scrollToIdBlock: function (e) {
      e.preventDefault();
      var thisLinkDataId = $(e.currentTarget).data('id'),
        $htmlBody = $('html, body');
      if (thisLinkDataId === 'slidetm1') {
        $htmlBody.animate({scrollTop: 0}, 500);
      } else {
        $htmlBody.animate({scrollTop: this.$('#' + thisLinkDataId + '').offset().top}, 500);
      }
    },

    /**
     * Метод для прокручивания новостей вверх.
     * @param {Event} e Событие
     */
    newsScrollUp: function (e) {
      var hiddenNewsblocks = $(e.currentTarget).parent().find('.newsbl').filter(function () {
        return $(this).css('display') === 'none';
      });
      var height = hiddenNewsblocks.hasClass('videobl') ? '170px' : '200px';
      hiddenNewsblocks.last().css({display: 'block'});
      hiddenNewsblocks.last().filter(':not(:animated)').animate(
        {
          'height': height,
          'opacity': 1,
          'padding': '20px',
          'margin-top': '-2px',
          'border': '2px solid #d9d9d9'
        }, 600);
    },

    /**
     * Метод для прокручивания новостей вниз.
     * @param {Event} e Событие
     */
    newsScrollDown: function (e) {
      var visibleNewsblocks = $(e.currentTarget).parent().find('.newsbl').filter(function () {
        return $(this).css('display') !== 'none';
      });
      if (visibleNewsblocks && visibleNewsblocks.length > 3) {
        visibleNewsblocks.first().filter(':not(:animated)').animate(
          {'height': 0, 'opacity': 0, 'padding': 0, 'margin-top': 0, 'border': 'none'},
          {
            duration: 600, complete: function () {
              $(this).css({display: 'none'});
            }
          });
      }
    },

    /**
     * Метод для переключения видео.
     * @param {Event} e Событие
     */
    toggleMainVideo: function (e) {
      var src = $(e.currentTarget).data('video-src');
      var poster = $(e.currentTarget).data('video-poster');
      var description = $(e.currentTarget).data('video-description'),
        that = this;
      var descriptionBlock = this.$('.js-descriptions-video');
      this.videoView.$el.fadeOut(400, function () {
        that.videoView.render(src, poster, description);
        that.videoView.$el.fadeIn();
      });
      if (descriptionBlock.length) {
        descriptionBlock.html(this.template({
          description: description,
        }));
      }
    }
  });
})(jQuery);

}.call(window));